import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetAmountReferrals = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_REFERRALS_BONUSES_REFERRALS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetAmountReferralsAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetAmountReferrals as SetGetAmountReferrals
}